/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import { MODE_APPOINTMENT } from 'client-portal/utils/prescreener/constants';
import { and, empty, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@tagName('')
export default class RequestRequestWrapperBody extends Component {
  @service currentPractice;
  @service session;
  @service prescreener;

  get modeAppointment() {
    return MODE_APPOINTMENT;
  }

  @empty('session.currentClient') isNewClient;
  @reads('activeSteps.firstObject.isActive') isFirstStep;
  @and('isNewClient', 'isFirstStep') showSignInBox;
}
